var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "#00B0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.026 91.5144H152.769V77.9009H159.589V91.5144H173.333V98.9122H159.589V112.526H152.769V98.9122H139.026V91.5144Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.026 91.5144H152.769V77.9009H159.589V91.5144H173.333V98.9122H159.589V112.526H152.769V98.9122H139.026V91.5144Z",
    stroke: "white",
    strokeWidth: 2.03152,
    strokeMiterlimit: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8416 130.82H61.8318C63.0696 130.82 63.2243 129.532 63.5338 128.555C63.6884 128.098 63.8431 127.6 63.9979 127.08C64.2299 126.582 64.3074 126.125 64.5394 125.481L74.3637 97.0181C74.5957 96.4779 74.673 96.0001 74.9052 95.4184C75.2145 94.5043 75.524 93.5694 75.9108 92.5097C76.1428 91.9489 76.2203 91.6165 76.3748 91.0348C76.9163 89.5596 78.9276 84.3035 79.0051 83.3063L89.9123 115.134C90.067 115.799 90.2218 116.776 91.15 116.776C92.5424 116.776 92.7744 115.01 93.2386 113.95L94.7084 110.481C95.25 109.068 99.0403 100.571 99.0403 100.114C99.0403 99.8021 98.1121 96.935 97.88 96.3948L86.4312 61.2218C86.1992 60.6816 85.5029 60.4531 84.7294 60.4531H74.209C73.1259 60.4531 72.6617 60.7441 72.3524 61.5751C72.1204 62.2607 71.8881 63.154 71.5788 63.881C70.7278 66.0002 69.4128 70.4669 68.4845 72.8976C66.9374 76.9489 65.3129 82.3506 63.8431 86.4226L62.296 90.91C61.9866 91.7204 61.7545 92.4266 61.445 93.2162C61.1357 94.0263 60.981 94.7328 60.6715 95.543L49.5321 126.914C49.2228 127.683 48.9133 128.431 48.6813 129.199C48.3718 130.093 48.7586 130.82 49.8416 130.82Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2598 129.677C97.2598 130.446 97.6467 130.82 98.4203 130.82H111.648C112.499 130.82 113.273 128.14 113.737 126.872L115.439 122.343C115.671 121.699 115.98 120.889 116.212 120.203C117.914 116.028 119.616 111.062 121.318 106.782L122.169 104.518C122.478 103.708 122.71 103.043 123.02 102.253L137.33 64.0265C138.878 59.622 139.187 60.453 125.263 60.453C123.561 60.453 123.406 61.7203 122.633 63.8603C122.401 64.5459 122.091 65.2313 121.782 65.9792L119.229 72.5651C118.61 74.0403 118.146 75.4321 117.527 76.9073C117.295 77.2812 117.295 77.5721 117.14 77.9876L108.941 98.8254C108.322 100.217 107.858 101.672 107.239 103.168C106.929 103.936 106.775 104.518 106.465 105.287C106.233 105.702 106.156 105.993 106.001 106.346C105.846 106.845 105.692 107.073 105.537 107.489C103.99 111.54 101.901 116.755 100.586 120.681C100.277 121.554 97.2598 129.012 97.2598 129.677Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6675 59.6431V59.747V59.8924C18.9768 61.4921 21.6843 67.787 22.2259 69.0335L32.5917 94.9822C35.2218 101.36 38.2387 109.338 40.7915 115.425C41.565 117.212 41.6423 118.583 43.0348 118.583C43.9631 118.583 44.8914 115.695 45.3554 114.636L51.0024 101.443C51.0024 100.633 42.0291 79.1304 40.7915 75.7856L34.7576 60.8273C34.2935 59.7054 34.2161 58.6665 32.9785 58.6665H19.8278C19.1315 58.6665 18.6675 59.0197 18.6675 59.6431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c4145aa2a534af5609a5c643e7486acd.svg";
export { ForwardRef as ReactComponent };